// laravel-echo over Reverb (Pusher protocol). Private channels are authorised
// by the API with the same Passport token the app uses: POST /api/v1/broadcasting/auth.
// This module is loaded on demand by store.js (only when VUE_APP_REVERB_KEY is
// set), so laravel-echo and pusher-js stay out of the main bundle.
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axios from "axios";
import { reverb } from "./config";

window.Pusher = Pusher;

export function createEcho() {
  const tls = reverb.scheme === "https";

  return new Echo({
    broadcaster: "reverb",
    key: reverb.key,
    wsHost: reverb.host,
    wsPort: reverb.port,
    wssPort: reverb.port,
    forceTLS: tls,
    enabledTransports: tls ? ["wss"] : ["ws"],
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        axios
          .post(
            "/api/v1/broadcasting/auth",
            { socket_id: socketId, channel_name: channel.name },
            { headers: { Authorization: "Bearer " + localStorage.getItem("jwt") } }
          )
          .then((response) => callback(null, response.data))
          .catch((error) => callback(error));
      },
    }),
  });
}
